//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.AgeRestriction
import com.tixforgigs.apax.models.Category
import com.tixforgigs.apax.models.EventState
import com.tixforgigs.apax.models.OrderTicket
import com.tixforgigs.apax.models.Organizer
import com.tixforgigs.apax.models.Venue

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The shop event model
* 
* @param beginsAt The date and time when the event begins
* @param eventId The event id
* @param eventTitle The localized event title
* @param timeZone The time zone id. (Europe/Berlin)
* @param ageRestriction 
* @param blurHash Sets the blur hash
* @param category 
* @param dbVersion The version from db. Used for requesting updates based on a version.
* @param description The localized description of the event
* @param doorsOpenAt The date and time when the event opens for the public
* @param endsAt The date and time when the event ends
* @param eventStatus 
* @param eventSubTitle The localized subtitle of the event
* @param headerImage The header image url of the event
* @param iconImage The icon (avatar) image url of the event
* @param isBoxOfficeAvailable Defines if a box office is available at the event
* @param isCancelled Defines if the event is cancelled
* @param isEndsAtVisible Defines if the end date is visible
* @param isFollowed Defines if the event is followed by the user
* @param organizer 
* @param shortDescription The short localized description of the event
* @param tickets The venue where the event is taking place
* @param timeZoneId The time zone id. (Europe/Berlin) -> NOT NULL
* @param venue 
* @param website The website url of the event
*/
@Serializable

data class OrderEvent (


      /* The date and time when the event begins */
    @SerialName(value = "beginsAt") @Required val beginsAt: kotlin.time.Instant,


      /* The event id */
    @SerialName(value = "eventId") @Required val eventId: kotlin.Int,


      /* The localized event title */
    @SerialName(value = "eventTitle") @Required val eventTitle: kotlin.String,


      /* The time zone id. (Europe/Berlin) */
    @Deprecated(message = "This property is deprecated.")
    @SerialName(value = "timeZone") @Required val timeZone: kotlin.String = "Europe/Berlin",


      @SerialName(value = "ageRestriction") val ageRestriction: AgeRestriction? = null,


      /* Sets the blur hash */
    @SerialName(value = "blurHash") val blurHash: kotlin.String? = null,


      @SerialName(value = "category") val category: Category? = null,


      /* The version from db. Used for requesting updates based on a version. */
    @SerialName(value = "dbVersion") val dbVersion: kotlin.Long? = 0L,


      /* The localized description of the event */
    @SerialName(value = "description") val description: kotlin.String? = null,


      /* The date and time when the event opens for the public */
    @SerialName(value = "doorsOpenAt") val doorsOpenAt: kotlin.time.Instant? = null,


      /* The date and time when the event ends */
    @SerialName(value = "endsAt") val endsAt: kotlin.time.Instant? = null,


      @SerialName(value = "eventStatus") val eventStatus: EventState? = null,


      /* The localized subtitle of the event */
    @SerialName(value = "eventSubTitle") val eventSubTitle: kotlin.String? = null,


      /* The header image url of the event */
    @SerialName(value = "headerImage") val headerImage: kotlin.uuid.Uuid? = null,


      /* The icon (avatar) image url of the event */
    @SerialName(value = "iconImage") val iconImage: kotlin.uuid.Uuid? = null,


      /* Defines if a box office is available at the event */
    @SerialName(value = "isBoxOfficeAvailable") val isBoxOfficeAvailable: kotlin.Boolean? = null,


      /* Defines if the event is cancelled */
    @Deprecated(message = "This property is deprecated.")
    @SerialName(value = "isCancelled") val isCancelled: kotlin.Boolean? = null,


      /* Defines if the end date is visible */
    @SerialName(value = "isEndsAtVisible") val isEndsAtVisible: kotlin.Boolean? = null,


      /* Defines if the event is followed by the user */
    @SerialName(value = "isFollowed") val isFollowed: kotlin.Boolean? = null,


      @SerialName(value = "organizer") val organizer: Organizer? = null,


      /* The short localized description of the event */
    @SerialName(value = "shortDescription") val shortDescription: kotlin.String? = null,


      /* The venue where the event is taking place */
    @SerialName(value = "tickets") val tickets: kotlin.collections.List<OrderTicket>? = null,


      /* The time zone id. (Europe/Berlin) -> NOT NULL */
    @SerialName(value = "timeZoneId") val timeZoneId: kotlin.String? = "Europe/Berlin",


      @SerialName(value = "venue") val venue: Venue? = null,


      /* The website url of the event */
    @SerialName(value = "website") val website: kotlin.String? = null


) {




  }

